import { render, staticRenderFns } from "./NotificationsBellV2.vue?vue&type=template&id=3cf69c9c&scoped=true"
import script from "./NotificationsBellV2.vue?vue&type=script&lang=js"
export * from "./NotificationsBellV2.vue?vue&type=script&lang=js"
import style0 from "./NotificationsBellV2.vue?vue&type=style&index=0&id=3cf69c9c&prod&scoped=true&lang=css"
import style1 from "./NotificationsBellV2.vue?vue&type=style&index=1&id=3cf69c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf69c9c",
  null
  
)

export default component.exports